import "./GlobalCategoryConfig.scss";
import CategoryGroups from "@/components/POI/CategoryGroups/CategoryGroups.vue";

export default {
  data: () => ({
    snackbarText: "",
    snackbarColor: "",
    snackbar: false
  }),
  async mounted() {
    try {
      await this.$store.dispatch("getCategoryGroups", true);
    } catch (err) {
      this.createError(err);
    }
  },
  computed: {
    categoryGroups() {
      return this.$store.state.categoryGroups;
    }
  },
  methods: {
    createError(ex) {
      this.snackbarText =
        "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal";
      this.snackbarColor = "#c55c52";
      this.snackbar = true;
      console.error(ex);
    },
    createSuccess(message) {
      this.snackbarText = message;
      this.snackbarColor = "#00636C";
      this.snackbar = true;
    }
  },
  components: { CategoryGroups }
};
